import React, { MouseEvent, useEffect } from "react";
import "./CarouselPopup.css";
import { usePopup } from "src/contexts/PopupContext";

const Close = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_457_13914)">
        <path
          d="M15.707 9.707L13.414 12L15.707 14.293C16.098 14.684 16.098 15.316 15.707 15.707C15.512 15.902 15.256 16 15 16C14.744 16 14.488 15.902 14.293 15.707L12 13.414L9.707 15.707C9.512 15.902 9.256 16 9 16C8.744 16 8.488 15.902 8.293 15.707C7.902 15.316 7.902 14.684 8.293 14.293L10.586 12L8.293 9.707C7.902 9.316 7.902 8.684 8.293 8.293C8.684 7.902 9.316 7.902 9.707 8.293L12 10.586L14.293 8.293C14.684 7.902 15.316 7.902 15.707 8.293C16.098 8.684 16.098 9.316 15.707 9.707ZM24 12C24 18.617 18.617 24 12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12ZM22 12C22 6.486 17.514 2 12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12Z"
          fill="#3A1914"
        />
      </g>
      <defs>
        <clipPath id="clip0_457_13914">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SmallPrev: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_441_13478)">
      <path
        d="M24 12C24 9.62662 23.2962 7.30655 21.9776 5.33315C20.6591 3.35976 18.7849 1.8217 16.5922 0.913445C14.3995 0.0051918 11.9867 -0.232449 9.65891 0.230576C7.33114 0.693598 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693598 7.33114 0.230576 9.65891C-0.232449 11.9867 0.0051918 14.3995 0.913445 16.5922C1.8217 18.7849 3.35976 20.6591 5.33315 21.9776C7.30655 23.2962 9.62662 24 12 24C15.1815 23.9966 18.2318 22.7312 20.4815 20.4815C22.7312 18.2318 23.9966 15.1815 24 12ZM2 12C2 10.0222 2.58649 8.08879 3.6853 6.4443C4.78412 4.7998 6.3459 3.51808 8.17316 2.7612C10.0004 2.00432 12.0111 1.80629 13.9509 2.19214C15.8907 2.578 17.6725 3.53041 19.0711 4.92893C20.4696 6.32746 21.422 8.10929 21.8079 10.0491C22.1937 11.9889 21.9957 13.9996 21.2388 15.8268C20.4819 17.6541 19.2002 19.2159 17.5557 20.3147C15.9112 21.4135 13.9778 22 12 22C9.34873 21.9971 6.80688 20.9426 4.93215 19.0679C3.05741 17.1931 2.00291 14.6513 2 12ZM10.879 17.707C11.0665 17.5195 11.1718 17.2652 11.1718 17C11.1718 16.7348 11.0665 16.4805 10.879 16.293L7.587 13L18 12.993C18.2652 12.993 18.5196 12.8876 18.7071 12.7001C18.8946 12.5126 19 12.2582 19 11.993C19 11.7278 18.8946 11.4734 18.7071 11.2859C18.5196 11.0984 18.2652 10.993 18 10.993L7.586 11L10.879 7.707C10.9775 7.6168 11.0569 7.50778 11.1126 7.38637C11.1683 7.26497 11.1991 7.13364 11.2032 7.00014C11.2073 6.86664 11.1846 6.73368 11.1364 6.60909C11.0883 6.4845 11.0157 6.37082 10.9229 6.27476C10.8301 6.17869 10.719 6.10219 10.5962 6.04976C10.4733 5.99733 10.3412 5.97005 10.2077 5.96951C10.0741 5.96897 9.94179 5.9952 9.81853 6.04663C9.69527 6.09807 9.58356 6.17368 9.49 6.269L9.465 6.293L5.879 9.878C5.60037 10.1566 5.37934 10.4873 5.22855 10.8513C5.07775 11.2153 5.00014 11.6055 5.00014 11.9995C5.00014 12.3935 5.07775 12.7837 5.22855 13.1477C5.37934 13.5117 5.60037 13.8424 5.879 14.121L9.465 17.707C9.65253 17.8945 9.90683 17.9998 10.172 17.9998C10.4372 17.9998 10.6915 17.8945 10.879 17.707Z"
        fill="#3A1914"
      />
    </g>
    <defs>
      <clipPath id="clip0_441_13478">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="matrix(-1 0 0 -1 24 24)"
        />
      </clipPath>
    </defs>
  </svg>
);

const SmallNext: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_441_13482)">
      <path
        d="M0 12C0 14.3734 0.703788 16.6935 2.02236 18.6668C3.34094 20.6402 5.21509 22.1783 7.4078 23.0866C9.60051 23.9948 12.0133 24.2324 14.3411 23.7694C16.6689 23.3064 18.8071 22.1635 20.4853 20.4853C22.1635 18.8071 23.3064 16.6689 23.7694 14.3411C24.2324 12.0133 23.9948 9.60051 23.0866 7.4078C22.1783 5.21509 20.6402 3.34094 18.6668 2.02236C16.6935 0.703788 14.3734 0 12 0C8.81846 0.00344108 5.76821 1.26883 3.51852 3.51852C1.26883 5.76821 0.00344108 8.81846 0 12ZM22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92893 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.7612 8.17317C3.51808 6.3459 4.79981 4.78412 6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C14.6513 2.00291 17.1931 3.05742 19.0679 4.93215C20.9426 6.80688 21.9971 9.34873 22 12ZM13.121 6.293C12.9335 6.48053 12.8282 6.73484 12.8282 7C12.8282 7.26516 12.9335 7.51947 13.121 7.707L16.413 11L6 11.007C5.73478 11.007 5.48043 11.1124 5.29289 11.2999C5.10536 11.4874 5 11.7418 5 12.007C5 12.2722 5.10536 12.5266 5.29289 12.7141C5.48043 12.9016 5.73478 13.007 6 13.007L16.414 13L13.121 16.293C13.0225 16.3832 12.9431 16.4922 12.8874 16.6136C12.8317 16.735 12.8009 16.8664 12.7968 16.9999C12.7927 17.1334 12.8154 17.2663 12.8636 17.3909C12.9117 17.5155 12.9843 17.6292 13.0771 17.7252C13.1699 17.8213 13.281 17.8978 13.4038 17.9502C13.5267 18.0027 13.6588 18.03 13.7923 18.0305C13.9259 18.031 14.0582 18.0048 14.1815 17.9534C14.3047 17.9019 14.4164 17.8263 14.51 17.731L14.535 17.707L18.121 14.122C18.3996 13.8434 18.6207 13.5127 18.7715 13.1487C18.9222 12.7847 18.9999 12.3945 18.9999 12.0005C18.9999 11.6065 18.9222 11.2163 18.7715 10.8523C18.6207 10.4883 18.3996 10.1576 18.121 9.879L14.535 6.293C14.3475 6.10553 14.0932 6.00021 13.828 6.00021C13.5628 6.00021 13.3085 6.10553 13.121 6.293Z"
        fill="#3A1914"
      />
    </g>
    <defs>
      <clipPath id="clip0_441_13482">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CarouselPopup: React.FC = () => {
  const { isCarouselVisible, carouselImages, setIsCarouselVisible } =
    usePopup();
  const [currentImage, setCurrentImage] = React.useState(0);

  useEffect(() => {
    setCurrentImage(0);
  }, [isCarouselVisible]);

  const hidePopup = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;
    setIsCarouselVisible(false);
  };

  const handleCloseButton = () => {
    setIsCarouselVisible(false);
  };

  const handlePrev = () => {
    if (currentImage === 0) return;
    setCurrentImage(currentImage - 1);
  };

  const handleNext = () => {
    if (currentImage === carouselImages.length - 1) return;
    setCurrentImage(currentImage + 1);
  };

  return (
    <>
      {isCarouselVisible && (
        <div className="carousel-popup" onClick={hidePopup}>
          <div>
            <div className="carousel-container">
              <button
                className={"carousel-popup-close"}
                onClick={handleCloseButton}
              >
                <Close />
              </button>

              <div className="carousel-current-image">
                <img
                  src={`${process.env.PUBLIC_URL}${carouselImages[currentImage]}`}
                  alt="Current"
                />
              </div>

              <div className="carousel-thumbnails">
                {carouselImages.map((image, index) => (
                  <div
                    key={`carousel-thumb-wrapper-${index}-${image}`}
                    className={
                      index === currentImage ? "selected-thumbnail" : ""
                    }
                  >
                    <img
                      key={`${index}-${image}`}
                      src={`${process.env.PUBLIC_URL}${image}`}
                      alt={`Thumbnail ${index}`}
                      onClick={() => setCurrentImage(index)}
                    />
                  </div>
                ))}
              </div>

              {carouselImages.length > 1 && (
                <div className="carousel-navigation">
                  <button onClick={handlePrev} className="prev-button">
                    <SmallPrev />
                  </button>
                  <button onClick={handleNext} className="next-button">
                    <SmallNext />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CarouselPopup;
